import type { TefComsCancelButton } from '@mfe/components/TefComsCancelButton';
import { html } from 'lit';

// a cancel button that triggers an event
export const tefComsCancelButton = function render(this: TefComsCancelButton) : ReturnType<typeof html> {
  return html`<button class="button button-default--prio-secondary" @click=${this.handleClick}>Dialog schließen</button>`;
};
